<div style="height: calc(100vh - 85px)">
    <router-outlet></router-outlet>
</div>
<app-loading-spinner></app-loading-spinner>
